export default __webpack_public_path__ + "static/media/factura.5597190c.svg";